<div class="px-4 py-4 bg-gray-50 space-y-4 flex flex-col gap-2">
    <form [formGroup]="form">
        <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">写真を選択（AI認識済み）</label>
            <div class="grid grid-cols-2 gap-2">
                <ng-container *ngFor="let img of images">
                    <button class="relative rounded-lg overflow-hidden border-2 transition-all"
                        [class.ring-2]="imageControl?.value?.includes(img.id)"
                        [class.ring-blue-200]="imageControl?.value?.includes(img.id)"
                        [class.border-blue-500]="imageControl?.value?.includes(img.id)"
                        [class.border-gray-200]="!imageControl?.value?.includes(img.id)" (click)="selectImg(img.id)"
                        type="button">
                        <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&amp;h=300&amp;fit=crop"
                            alt="園庭" class="w-full aspect-video object-cover">
                        <div
                            class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-1.5">
                            <p class="text-white text-xs">園庭</p>
                        </div>
                        <div *ngIf="imageControl?.value?.includes(img.id)"
                            class="absolute top-1.5 right-1.5 w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-check w-3 h-3 text-white">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg>
                        </div>
                    </button>
                </ng-container>

            </div>
        </div>
        <div><label class="block text-sm font-medium text-gray-700 mb-2">活動内容</label>
            <div class="relative"><select formControlName="activity"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white text-sm">
                    <option value="">選択してください</option>
                    <option value="自由遊び">自由遊び</option>
                    <option value="製作活動">製作活動</option>
                    <option value="外遊び">外遊び</option>
                    <option value="音楽活動">音楽活動</option>
                    <option value="読書">読書</option>
                </select><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none">
                    <path d="m6 9 6 6 6-6"></path>
                </svg></div>
        </div>
        <div><label class="block text-sm font-medium text-gray-700 mb-2">時間</label>
            <input type="time" formControlName="date"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
        </div>
        <div><label class="block text-sm font-medium text-gray-700 mb-2">様子・メモ</label>
            <textarea rows="3" formControlName="detail"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none text-sm"></textarea>
        </div>
    </form>

</div>